function PaymentAmount(principal, ratePerPeriod, totalPeriods) {
  return principal * ((ratePerPeriod * Math.pow(1 + ratePerPeriod, totalPeriods)) / (Math.pow(1 + ratePerPeriod, totalPeriods) - 1));
}

function RemainingBalance(principal, ratePerPeriod, payment, paymentsMade) {
  return (principal * Math.pow(1 + ratePerPeriod, paymentsMade)) - ((payment / ratePerPeriod) * (Math.pow(1 + ratePerPeriod, paymentsMade) - 1));
}

function RatePerPeriodDecimal(apr, periods) {
  return apr / periods / 100;
}

export {
  PaymentAmount,
  RemainingBalance,
  RatePerPeriodDecimal,
}